<div>
  <mat-card class="collection-preview-card mini inverse-surface overlay">
    <mat-card-content class="slider-padding" matTooltip="Zoom in to use the imagery timeline" matTooltipShowDelay="0" matTooltipHideDelay="0">
      <div class="timeline">
        <div class="step step-one"></div>
        <div class="step step-two"></div>
      </div>
    </mat-card-content>

    @if((flagService.getFlags$() | async)?.[FeatureFlags.COLLECTION_FILTER] && !viewerService.is3DMode()){

    <div class="filter-button" matTooltip="{{
        enabledFilters
          ? 'Click here to filter imagery on the map'
          : showSwipeTooltip
          ? 'Filters were reset due to Before/After tool incompatibility. Exit the tool to use them.'
          : ''
      }}" matTooltipPosition="after">
      <button
        cdkOverlayOrigin
        #triggerFilter="cdkOverlayOrigin"
        [disabled]="!enabledFilters"
        matIconButton
        (click)="showFilters = !showFilters">
        <mat-icon #filterButton>filter_alt</mat-icon>
      </button>
    </div>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="triggerFilter"
      [cdkConnectedOverlayOpen]="showFilters"
      [cdkConnectedOverlayPositions]="[
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]">
      <app-collections-timeline-filter (onClose)="showFilters = false" (onUpdateProjects)="applyTimelineFilter($event)"></app-collections-timeline-filter>
    </ng-template>

    }
  </mat-card>
</div>
